import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, TextCharLimit, SwitchCheckbox} from 'views/components';
import {translate} from 'views/module';

const ContentNew = (props) => {
  const careviewItem = props.careviewItem;
  const setCareviewItem = props.setCareviewItem;

  const questionTitle = careviewItem.questionData.questionTitle;
  const enabledOnYes = careviewItem.questionData.followUpYesNo.enabledOnYes;
  const enabledOnNo = careviewItem.questionData.followUpYesNo.enabledOnNo;

  const setQuestionTitle = (value) => {
    setCareviewItem((e) => {
      return {
        ...e,
        questionTitle: value,
      };
    });
  };
  const setEnabledOnYes = (value) => {
    setCareviewItem((e) => {
      return {
        ...e,
        followUpYesNo: {
          ...e.followUpYesNo,
          enabledOnYes: value,
        },
      };
    });
  };
  const setEnabledOnNo = (value) => {
    setCareviewItem((e) => {
      return {
        ...e,
        followUpYesNo: {
          ...e.followUpYesNo,
          enabledOnNo: value,
        },
      };
    });
  };

  return (
    <Box>
      <Stack>
        <TextCharLimit
          label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Question')}
          placeholder={translate('client.ClientDetail.CareviewSettings.Types.YesNo.Question')}
          value={questionTitle}
          onChange={setQuestionTitle}
          charLimit={180}
          autoFocus
          fullWidth
        />
        <SwitchCheckbox
          label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.FollowupEnabledQuestionYes')}
          value={enabledOnYes}
          onChange={setEnabledOnYes}
        />
        <SwitchCheckbox
          label={translate('client.ClientDetail.CareviewSettings.Types.YesNo.FollowupEnabledQuestionNo')}
          value={enabledOnNo}
          onChange={setEnabledOnNo}
        />
      </Stack>
    </Box>
  );
};

ContentNew.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  setCareviewItem: PropTypes.func.isRequired,
};
export default React.memo(ContentNew);
